import { useRef, useEffect, useState } from "react";

/**
 * NOTE: this only enables HORIZONTAL dragging to scroll on a container.
 * // expand if we need later
 */
export function useDragToScroll() {
    const ref = useRef<HTMLDivElement | null>(null);
    const [isDragging, setIsDragging] = useState(false);
    const position = useRef({ x: 0, scrollLeft: 0 });

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const handleMouseDown = (e: MouseEvent) => {
            setIsDragging(true);
            position.current = {
                x: e.clientX,
                scrollLeft: el.scrollLeft,
            };
            //el.classList.add("is-dragging");
        };

        const handleMouseMove = (e: MouseEvent) => {
            if (!isDragging) return;
            const dx = e.clientX - position.current.x;
            el.scrollLeft = position.current.scrollLeft - dx;
        };

        const handleMouseUpOrLeave = () => {
            setIsDragging(false);
            //el.classList.remove("is-dragging");
        };

        el.addEventListener("mousedown", handleMouseDown);
        el.addEventListener("mousemove", handleMouseMove);
        el.addEventListener("mouseup", handleMouseUpOrLeave);
        el.addEventListener("mouseleave", handleMouseUpOrLeave);

        return () => {
            el.removeEventListener("mousedown", handleMouseDown);
            el.removeEventListener("mousemove", handleMouseMove);
            el.removeEventListener("mouseup", handleMouseUpOrLeave);
            el.removeEventListener("mouseleave", handleMouseUpOrLeave);
        };
    }, [isDragging]);

    return { ref: ref, isDragging: isDragging };
}
